const PRESET_TAB_STYLES = [
  { key: 'tab-0', width: '100px', opacity: 1 },
  { key: 'tab-1', width: '90px', opacity: 0.5 },
  { key: 'tab-2', width: '90px', opacity: 0.5 },
  { key: 'tab-3', width: '90px', opacity: 0.5 },
  { key: 'tab-4', width: '80px', opacity: 0.5 },
];

const TabsSkeleton = () => (
  <div className='flex gap-2 overflow-x-auto scrollbar-hide pb-0 pl-4 xs:pl-0'>
    {PRESET_TAB_STYLES.map(({ key, ...style }) => (
      <div key={key} className='h-9 bg-tertiary rounded-full shrink-0' style={style} />
    ))}
  </div>
);

const SectionHeaderSkeleton = () => (
  <div className='flex items-center gap-3 mb-4'>
    <div className='h-10 w-10 bg-tertiary rounded-lg' />
    <div className='h-6 w-32 bg-tertiary rounded-sm' />
  </div>
);

const CardSkeleton = () => (
  <div className='flex flex-col gap-4 py-5 px-4 sm:p-6 border border-extra-soft rounded-md bg-surface-primary'>
    <div className='flex flex-row w-full gap-2 sm:gap-4'>
      <div className='h-5 w-5 bg-tertiary rounded-full shrink-0' />
      <div className='flex-1 space-y-2'>
        <div className='h-5 bg-tertiary rounded-sm w-3/4' />
        <div className='h-4 bg-tertiary rounded-sm w-1/2 opacity-70' />
      </div>
      <div className='flex flex-col items-end gap-2 shrink-0'>
        <div className='h-4 w-4 bg-tertiary rounded-sm' />
        <div className='h-5 w-16 bg-tertiary rounded-sm' />
      </div>
    </div>
  </div>
);

const SectionSkeleton = ({ cardCount = 3 }: { cardCount?: number }) => (
  <div className='space-y-4'>
    <SectionHeaderSkeleton />
    <div className='space-y-4'>
      {Array.from({ length: cardCount }, (_, i) => (
        <CardSkeleton key={`preset-card-${i}`} />
      ))}
    </div>
  </div>
);

export const PresetsHomeSkeleton = () => {
  return (
    <div className='flex flex-col flex-1 overflow-hidden'>
      <div className='flex flex-col h-full pb-5 overflow-hidden overflow-y-auto scrollbar scrollbar-hide'>
        <div className='animate-pulse'>
          <header className='flex flex-col w-full flex-wrap py-5 pt-3 xs:pt-5 pb-6 sm:pb-8'>
            <div className='mb-4 xs:mb-6 px-4 xs:px-6 lg:px-10'>
              <div className='h-8 lg:h-10 w-32 bg-tertiary rounded-sm' />
            </div>
            <div className='flex items-start justify-between w-full gap-3 xs:px-6 lg:px-10'>
              <TabsSkeleton />
              <div className='hidden md:block h-9 w-36 bg-tertiary rounded-sm shrink-0' />
            </div>
          </header>
          <div className='px-4 xs:px-6 lg:px-10 space-y-12'>
            <SectionSkeleton cardCount={2} />
            <SectionSkeleton cardCount={3} />
            <SectionSkeleton cardCount={2} />
          </div>
        </div>
      </div>
    </div>
  );
};
